import { render, staticRenderFns } from "./FluxBar.vue?vue&type=template&id=cf13bf26&scoped=true&"
import script from "./FluxBar.vue?vue&type=script&lang=js&"
export * from "./FluxBar.vue?vue&type=script&lang=js&"
import style0 from "./FluxBar.vue?vue&type=style&index=0&id=cf13bf26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf13bf26",
  null
  
)

export default component.exports